import { eTipoFile } from '@/core/model/GloblasEnum';
import { saveAs } from 'file-saver';
import { Base64ToArrayBuffer } from './base/GlobalFunctios';

export class StorageService
{
  public async SaveFile(fileName: string, content: any,type:string)
  {
    if(content)
    {    
      const blob = new Blob([content] , { type: type});
      saveAs(blob,  fileName? fileName:'file-document' );  
    }      
  }
  protected base64ToArrayBuffer(base64: string):ArrayBufferLike
  {
    return Base64ToArrayBuffer(base64);
  }
  public async SaveBase64String(fileName: string, content: string)
  {
    if(content)
    {    
      const blob = new Blob([Base64ToArrayBuffer(content)]);
      saveAs(blob,  fileName? fileName:'file-document');    
    }      
  }  
  protected getTypeDoc(type:any):eTipoFile
  {       
    let tipo: any = eTipoFile.Other;      
    switch(type)
    {
      case 'image/apng': //Animated Portable Network Graphics (APNG)
      case 'image/avif' : //AV1 Image File Format (AVIF)
      case 'image/gif': //Graphics Interchange Format (GIF)
      case 'image/jpeg': //Joint Photographic Expert Group image (JPEG)
      case 'image/png': //Portable Network Graphics (PNG)
      case 'image/svg+xml': //Scalable Vector Graphics (SVG)
      case 'image/webp': //Web Picture format (WEBP)          
        tipo = eTipoFile.Image;
        
        break;
      case 'application/pdf':
        tipo = eTipoFile.Pdf;
        break;
    }
    return tipo;

  }
}